/** Energy-assistance program years run from October through September. */
export function applicableProgramYear(date: string | Date): number | null {
  const match = typeof date === "string" ? date.match(/^(\d{4})-(\d{2})-(\d{2})/) : null
  if (match) {
    const year = Number(match[1])
    const month = Number(match[2])
    const day = Number(match[3])
    const parsed = new Date(Date.UTC(year, month - 1, day))
    if (Number.isInteger(year) && month >= 1 && month <= 12 && day >= 1 && day <= 31 &&
      parsed.getUTCFullYear() === year && parsed.getUTCMonth() === month - 1 && parsed.getUTCDate() === day) {
      return month >= 10 ? year + 1 : year
    }
    return null
  }

  if (typeof date === "string") return null
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "numeric",
  }).formatToParts(date)
  const year = Number(parts.find((part) => part.type === "year")?.value)
  const month = Number(parts.find((part) => part.type === "month")?.value)
  return Number.isInteger(year) && month >= 1 && month <= 12
    ? (month >= 10 ? year + 1 : year)
    : null
}

export function currentApplicableProgramYear(today = new Date()): number {
  return applicableProgramYear(today) ?? today.getFullYear()
}
